// ManagerMenu.js

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
    FaRegCalendarAlt,
    FaRegChartBar,
    FaIndustry,
    FaUserTie,
    FaChartPie,
    FaMedkit,
    FaDollarSign,
    FaHistory,
    FaFileExcel,
    FaUser
} from 'react-icons/fa';
import './ManagerMenu.css';
import { downloadPivotReport } from '../api';

const handleDownloadPivotReport = () => {
    downloadPivotReport();
};

const handleLogout = () => {
    localStorage.removeItem('managerToken');
    window.location.href = '/';
};

const ManagerMenu = () => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    return (
        <nav className="manager-menu">
            <ul className="menu-left">
                <li>
                    <Link to="/manager/daily-reports">
                        <FaRegCalendarAlt className="menu-icon" /> Дневные отчеты
                    </Link>
                </li>
                <li>
                    <Link to="/manager/monthly-reports">
                        <FaRegChartBar className="menu-icon" /> Табель
                    </Link>
                </li>
                <li>
                    <Link to="/manager/factories">
                        <FaIndustry className="menu-icon" /> Заводы
                    </Link>
                </li>
                <li>
                    <Link to="/manager/masters">
                        <FaUserTie className="menu-icon" /> Мастера
                    </Link>
                </li>
                <li>
                    <Link to="/manager/analytics">
                        <FaChartPie className="menu-icon" /> Аналитика
                    </Link>
                </li>

                <li>
                    <Link to="/manager/sick-leave">
                        <FaMedkit className="menu-icon" /> Больничные {/* Новый пункт меню */}
                    </Link>
                </li>

                <li>
                    <Link to="/manager/finance">
                        <FaDollarSign className="menu-icon" /> Финансы
                    </Link>
                </li>

            </ul>
            <ul className="menu-right">
                <li>
                    <Link to="/manager/changelog">
                        <FaHistory className="menu-icon" /> Журнал изменений
                    </Link>
                </li>
                <li>
                    <button
                        onClick={handleDownloadPivotReport}
                        className="menu-button"
                        type="button"
                        aria-label="Скачать сводный отчет"
                        title="Скачать сводный отчет"
                    >
                        <FaFileExcel className="menu-icon" />
                    </button>
                </li>
                <li className="user-dropdown">
                    <button
                        className="menu-button user-menu-button"
                        onClick={() => setDropdownOpen(!dropdownOpen)}
                        type="button"
                        aria-label="Меню пользователя"
                        title="Меню пользователя"
                    >
                        <FaUser className="menu-icon" />
                    </button>
                    {dropdownOpen && (
                        <div 
                            className="dropdown-menu"
                            onMouseEnter={() => setDropdownOpen(true)}
                            onMouseLeave={() => setDropdownOpen(false)}
                        >
                            <button onClick={handleLogout} className="dropdown-item">
                                Выйти
                            </button>
                        </div>
                    )}
                </li>
            </ul>
        </nav>
    );
};

export default ManagerMenu;
